import template from './autocomplete.html';
import _ from 'lodash';

function Autocomplete($timeout) {
	'ngInject';

	const directive = {
		link,
		template,
		'restrict': 'E',
		'transclude': true,
		'scope': {
			// Placeholder of the input
			'placeholderText': '@placeholderText',
			'onFocus': '=',
			'search': '=',
			// Delay to timeout the requests for the search
			'delay': '=',
			// Function for clearing results
			'clearResults': '=',
			// The ngModel of the input
			'query': '=',
			'active': '@active',
			// The class of the input
			'inputClass': '@inputClass',
			// The class of the label
			'labelClass': '@labelClass',
			// The placeholder of the input
			'labelText': '@',
			// Icon name
			'icon': '@icon',
			// Handle selecting an item function
			'selectItem': '=',
			// Check if there is selected item
			'selectedItem': '=',
			'iconClass': '@iconClass',
			'inputId': '@inputId',
			'required': '@'
		}
	};

	return directive;

	function link(scope, element) {
		let results = [];
		let activeIndex = 0;
		let loseFocusTimeout = null;
		let searchInProgress = null;

		scope.showResults = false;
		scope.timeoutSearch = _.debounce(timeoutSearch, 200);
		scope.onFocusLost = onFocusLost;

		element.find('input')[0].addEventListener('focus', function(e) {
			if (scope.onFocus) {
				return scope.onFocus(e);
			}
		});

		element[0].addEventListener('keydown', onKeyPressed);

		/**
		 * Function bind to the change event on the input.
		 * After a brief timeout a request will be send to the API.
		 * @param {String} query
		 */
		function timeoutSearch(query, active) {
			scope.showResults = false;
			scope.clearResults();

			searchInProgress = scope.search(query, active)
					.then(function(res) {
						scope.showResults = true;
						if (!res.data && res.length) {
							activeIndex = 0;
							results = res;
							// Set the text for the autocomplete in same property for easy access
							results.forEach(function(result) {
								if (result.translation) {
									result.autocompleteValue = result.translation.name;
								} else if (result.names) {
									result.autocompleteValue = result.names;
								} else {
									result.autocompleteValue = result.name;
								}
							});
							results[activeIndex].active = true;
						}
					});
		}

		/**
		 * Function bind to the blur event on the input.
		 * When the input lose focus after a brief timeout the results will be cleared.
		 */
		function onFocusLost() {
			$timeout.cancel(loseFocusTimeout);

			loseFocusTimeout = $timeout(function() {
				if (searchInProgress) {
					searchInProgress.then(focusLost);
				} else {
					focusLost();
				}
			}, 300);

			function focusLost() {
				const foundCity = _.find(results, function(item) {
					return item.autocompleteValue.match(new RegExp(scope.query, 'i'));
				});

				if (scope.query && foundCity) {
					scope.selectItem(foundCity);
				} else if (!foundCity) {
					scope.query = '';
				}

				// Resolves a bug caused by the digest cycles that doesn't set scope.selectedItem when there is foundCity
				$timeout(function() {
					// Checks if there is a selected item and clear the input if there is not
					if (!scope.selectedItem) {
						scope.query = '';
					}
				});

				scope.showResults = false;
				scope.clearResults();
				results = [];
			}
		}

		function onKeyPressed(event) {
			if (event.keyCode === 13 || event.keyCode === 40 || event.keyCode === 38) {
				event.preventDefault();
				console.log(event);
			}

			if (results.length) {
				scope.$apply(function() {
					switch (event.keyCode) {
					// Enter
					case 13:
						scope.selectItem(results[activeIndex]);
						scope.showResults = false;
						// scope.clearResults();
						event.target.blur();
						// results = [];
						break;
					// Down arrow
					case 40:
						results[activeIndex].active = false;
						activeIndex = activeIndex + 1 > results.length - 1 ? activeIndex : activeIndex + 1;
						results[activeIndex].active = true;
						scope.query = results[activeIndex].autocompleteValue;
						break;
					// Up arrow
					case 38:
						results[activeIndex].active = false;
						activeIndex = activeIndex - 1 < 0 ? 0 : activeIndex - 1;
						results[activeIndex].active = true;
						scope.query = results[activeIndex].autocompleteValue;
						break;
					default:
						break;
					}
				});
			}
		}
	}
}

export default Autocomplete;



/** WEBPACK FOOTER **
 ** ./client/components/autocomplete/autocomplete.directive.js
 **/